import DbTruncate from "../../pages/Private/dbTruncate";

export const PrivateSettings = [
    { path: "/db-truncate", component: <DbTruncate /> }
]